import React from 'react'
import { Grid } from '@material-ui/core'
import { Container } from '@material-ui/core'
import mailFoot from '../../../assets/logos/mail_foot.png'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { PromotionalFooterPure } from '../../pures'
import './configuration-email-renovation.css'


const ConfigurationEmailRenovationPure = (props) => {
  const { t } = useTranslation()

  const globalContainerStyles = {
    display: 'inline-block',
    justifyContent: 'flex-start',
    maxWidth: '100%'
  }

  const containerTableAndHeadersStyles = {
    marginTop: '20px',
    display: 'grid'
  }

  return (
    <div style={{marginLeft:'5px'}}>
      <Container className='container' spacing={4} lg={12} md={12} style={globalContainerStyles} >
        <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation' style={containerTableAndHeadersStyles}>
          <img alt='MailFoot' src={mailFoot} />
        </Grid>
        <Grid container className='form' lg={12} md={12}>
          <Grid container className='form' lg={12} md={12}>
            <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation'>
              <p>{t('configurationEmailRenovation.sendEmail')}</p>
            </Grid>
            <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation'>
              <span className='color-email oblique'>{props.email}</span>
            </Grid>
            <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation message-renovation'>
              <p>{t('configurationEmailRenovation.messagePart1')} <strong>{t('configurationEmailRenovation.messagePart2')}</strong> {t('configurationEmailRenovation.messagePart3')} <span className='oblique' >{t('configurationEmailRenovation.messagePart4')}</span></p>
            </Grid>
            <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation'>
              <span className='color-email oblique'>Ventas: {t('informationContactInvited.supportInfo')} / {t('informationContactInvited.salesInfo')  }</span>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='button-back-configuration-email'>
            <Link to='/configuration' className='button-decoration'>
              <button onClick={props.scrollWindow} className="form-button-back-configuration">{t('configurationEmailRenovation.buttonBack')}</button>
            </Link>
          </Grid>
          <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={containerTableAndHeadersStyles}>
            {/* <PromotionalFooterPure /> */}
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export { ConfigurationEmailRenovationPure as default }
